import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftCircleOutlined = _resolveComponent("LeftCircleOutlined")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_link, { to: $props.backPath }, {
      default: _withCtx(() => [
        _createVNode(_component_LeftCircleOutlined),
        _createTextVNode(" 返回 ")
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["to"]),
    _createCommentVNode("<a-breadcrumb>"),
    _createCommentVNode("    <a-breadcrumb-item>"),
    _createCommentVNode("        <router-link :to=\"backPath\">"),
    _createCommentVNode("            <LeftCircleOutlined />"),
    _createCommentVNode("            {{ backName }}"),
    _createCommentVNode("        </router-link>"),
    _createCommentVNode("    </a-breadcrumb-item>"),
    _createCommentVNode("    <a-breadcrumb-item>"),
    _createCommentVNode("        {{ currentName }}"),
    _createCommentVNode("    </a-breadcrumb-item>"),
    _createCommentVNode("</a-breadcrumb>")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}